<template>
  <dash-board-layout
    :active="4"
    :title="true"
    :activeSetting="3"
    :setting="true"
  >
    <div class="card">
      <div class="card-header">
        <h4 class="card-title">Security</h4>
      </div>
      <div class="card-body account-security">
        <div class="row align-items-center two-factor-authentication">
          <div slot="header">
            <h3></h3>
          </div>
          <div>
            <el-alert title active="true" color="none" :closable="false">
              <p>Using Two-factor authentication is mandatory.</p>
              <p>
                Please consider our available options for increasing the
                security of your account. We want to give you every opportunity
                to be confident that your account is secure.
              </p>
              <p>Your current coverage</p>

              <ul class="current-coverage" style="margin: 13px">
                <li class="current-coverage-item">
                  <i
                    :class="`fa fa-check-circle-o fa-fw ${
                      hasBind ? 'checked' : ''
                    }`"
                  ></i
                  >Logins
                </li>
                <li class="current-coverage-item">
                  <i
                    :class="`fa fa-check-circle-o fa-fw ${
                      hasBind ? 'checked' : ''
                    }`"
                  ></i
                  >Withdrawal Confirmations
                </li>
                <li class="current-coverage-item">
                  <i
                    :class="`fa fa-check-circle-o fa-fw ${
                      hasBind ? 'checked' : ''
                    }`"
                  ></i
                  >Password Changes
                </li>
                <li class="current-coverage-item">
                  <i
                    :class="`fa fa-check-circle-o fa-fw ${
                      hasBind ? 'checked' : ''
                    }`"
                  ></i
                  >API Key Creation
                </li>
                <li class="current-coverage-item">
                  <i
                    :class="`fa fa-check-circle-o fa-fw ${
                      hasBind ? 'checked' : ''
                    }`"
                  ></i
                  >Security Settings Changes
                </li>
                <li class="current-coverage-item">
                  <i
                    :class="`fa fa-check-circle-o fa-fw ${
                      hasBind ? 'checked' : ''
                    }`"
                  ></i
                  >Sensitive Account Settings Changes
                </li>
              </ul>
            </el-alert>

            <div class="row" style="margin: 15px 0 15px 0">
              <div class="col-12">
                <p style="margin: 15px 0 15px 0">
                  Use Google's Android or iPhone app for adding token-based 2FA.
                </p>
              </div>
              <div class="col-6" style="text-align: right">
                <el-button color="primary" type="border">App Store</el-button>
              </div>
              <div class="col-6" style="text-align: left">
                <el-button color="primary" type="border">Google Play</el-button>
              </div>
            </div>

            <el-alert
              title
              active="true"
              type="success"
              color="none"
              :closable="false"
              v-if="hasBind"
            >
              <p>
                The account has been bound to Google's two-step verification
              </p>
            </el-alert>

            <el-alert
              title
              active="true"
              color="none"
              :closable="false"
              v-if="!hasBind"
            >
              <p>
                Open the Google Authenticator, scan the QR code below or
                manually enter the key below to add a verification token.
              </p>
              <p>
                The key is used to retrieve the Google Authenticator when the
                phone is replaced or lost, and be sure to save the following key
                backup before binding.
              </p>
            </el-alert>
            <div>
            <el-image
              v-if="googleInfo"
              :src="`data:image/png;base64,${googleInfo.generateQR}`"
            />
            </div>
            <el-alert
              title
              active="true"
              color="none"
              :closable="false"
              v-if="googleInfo"
            >
              <p>
                Secret：{{ googleInfo.secret.base32 }}
              </p>
                <a @click="copyText" style="float:right;">copy</a>
            </el-alert>

            <div
              class="row"
              style="margin: 15px 0 15px 0"
              v-if="!hasBind"
            >
              <div class="col-12">
                <p style="margin: 15px 0 15px 0">
                  Verify the Google verification code
                </p>
              </div>
              <div class="col-6" style="text-align: right">
                <el-input
                  v-verify="code"
                  v-validate="'required'"
                  maxlength="6"
                  v-model="code"
                  class="inline-flex"
                />
              </div>
              <div class="col-3" style="text-align: left">
                <el-button @click="bind">Bind</el-button>
              </div>
              <label class="error" v-remind="code"></label>
            </div>

          </div>
        </div>
      </div>
    </div>

    <el-dialog
      title="prompt"
      :visible.sync="dialogVisible"
      :show-close="false"
      :close-on-click-modal="false"
      :append-to-body="true"
      :lock-scroll="true"
    >
      <span
        >Using Two-factor authentication is mandatory. <br />Start using Google
        Authenticator now.
      </span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancel">Cancel</el-button>
        <el-button type="primary" @click="createGoogleAuth">Enter</el-button>
      </span>
    </el-dialog>
  </dash-board-layout>
</template>

<script>
import {
  createGoogleCode,
  googleCodeStatus,
  bindGoogleCode,
} from "@/plugins/api/security";
import DashBoardLayout from "../../../components/layouts/DashBoardLayout.vue";

export default {
  components: { DashBoardLayout },
  data() {
    return {
      googleInfo: undefined,
      hasBind: false,
      code: "",
      dialogVisible: false,
    };
  },
  verify: {
    code: [
      {
        minLength: 6,
        message: "The verification code must not be less than 6 digits",
      },
      {
        maxLength: 6,
        message: "The verification code must not be more than 6 digits",
      },
    ],
  },
  created() {
    googleCodeStatus().then((status) => {
      if (status == 0) {
        this.dialogVisible = true;
      } else {
        this.dialogVisible = false;
        this.hasBind = true;
      }
    });
  },
  methods: {
    cancel() {
      this.$router.push("/dashboard");
      this.$destroy()
    },
    createGoogleAuth() {
      createGoogleCode().then((res) => {
        this.googleInfo = res;
        this.dialogVisible = false;
      });
    },
    onCopy: function (e) {
      alert("You just copied: " + e.text);
    },
    onError: function (e) {
      alert("Failed to copy texts");
    },
    bind() {
      // do nothing
      const thisIns = this;

      if (thisIns.$verify.check()) {
        bindGoogleCode({ code: this.code }).then((res) => {
          thisIns.$Message.success(
            "Google's two-step verification binding was successful"
          );
          setTimeout(() => {
            // thisIns.$router.push("/setting/security");
            thisIns.$router.push("/dashboard");
          }, 2000);
        });
      }
    },
    copyText() {
      const thisIns = this;
      thisIns.$copyText(this.googleInfo.secret.base32).then(
        function () {
          thisIns.$Message.success("copid");
        },
        function () {
          thisIns.$Message.warning("copy failed");
        }
      );
    },
  },
};
</script>


<style scoped>
.account-security .two-factor-authentication .current-coverage {
  /* display: -webkit-flex; */
  /* display: flex; */
  -webkit-justify-content: flex-start;
  justify-content: flex-start;
}

.account-security
  .two-factor-authentication
  .current-coverage
  .current-coverage-item {
  -webkit-flex: 0 0 33.33%;
  flex: 0 0 33.33%;
  font-size: 13px;
  padding-bottom: 8px;
  display: -webkit-flex;
  /* display: flex; */
}
.account-security
  .two-factor-authentication
  .current-coverage
  .fa-check-circle-o,
.account-security
  .two-factor-authentication
  .current-coverage
  .fa-times-circle-o {
  margin-right: 5px;
  font-size: 23px;
}

.account-security .fa-check-circle-o.checked,
.account-security .fa-check-circle-o.checked {
  color: #01a781 !important;
  color: var(--primary-color);
}

.error {
  color: red;
}
</style>